import { Injectable } from "@angular/core";
import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import { Observable, catchError, from, map, of } from "rxjs";
import {
  HandlerBuilder,
  HttpMethod,
} from "@app/core/shared/data/network/base-handler.parameters";
import { TokenAuthorization } from "@app/core/shared/data/network/token-authorization";
import { Share, ShareResult } from "@capacitor/share";

@Injectable({ providedIn: "root" })
export class ShareMessageMobileWeb {
  constructor() {}

  execute(message: string, url: string): Observable<string> {
    let shareData = {
      title: "",
      text: message,
      url: url,
    };
    //For analytics we need to return the platform were it's shared
    return from(navigator.share(shareData)).pipe(
      map((ret) => "mobile-web"),
      catchError((err) => of("error not catched"))
    );
  }
}
